import React, { useEffect, useRef, useState } from 'react';
import Collapse from 'react-css-collapse';
import Tooltip from 'react-tooltip-lite';

import { ReactComponent as Checkmark } from '../../images/checkmark.svg';
import caret from '../../images/icons/caret.png';
import { ReactComponent as ArrowDown } from '../../images/icons/chevron-down.svg';
import { ReactComponent as QuestionMark } from '../../images/question-icon.svg';
import * as styles from './FeatureTable.module.css';

/* eslint-disable */
const CollapsableSection = ({ title, tiers, features, openByDefault = false, setIsVisible, index, visible }) => {
  const [open, setOpen] = useState(openByDefault);
  const collapseRef = useRef();
  const observerCallback = (entries) => {
    const [entry] = entries;
    setIsVisible(index, entry.isIntersecting);
  };
  let rootMargin = '0px';
  if (typeof window !== 'undefined') {
    const nav = document.getElementsByClassName('sticky-nav');
    if (nav && nav.length > 0) {
      rootMargin = '-84px 0px 0px 0px';
    }
  }
  const options = { rootMargin };

  useEffect(() => {
    const observer = new IntersectionObserver(observerCallback, options);
    if (collapseRef.current) {
      observer.observe(collapseRef.current);
    }
    return () => {
      if (collapseRef.current) {
        observer.unobserve(collapseRef.current);
      }
    };
  }, [collapseRef, options]);

  return (
    <div>
      <div className={styles.title} onClick={() => setOpen(!open)} style={{ '--tierCount': tiers.length }}>
        <h4 ref={collapseRef}>{title}</h4>
        {tiers.map((tier, i) => (
          <div className={styles.tierHiddenHeading}>
            <h4 className={(index !== 0 && visible && styles.showTier) || styles.hideTier} key={i}>
              {tier}
            </h4>
            {i === tiers.length - 1 && <ArrowDown className={open ? styles.flip : ''} />}
          </div>
        ))}
      </div>
      <Collapse isOpen={open}>
        {features.map((feature, i) => {
          return (
            <div key={i} className={styles.row} style={{ '--tierCount': tiers.length }}>
              <div className={styles.feature}>
                <Tooltip
                  direction={'right'}
                  spacing={10}
                  distance={20}
                  tagName={'span'}
                  arrowSize={15}
                  arrowContent={<img src={caret} alt={''} />}
                  content={<div className={styles.toolTipWrap}>{feature.tooltip}</div>}
                >
                  <p>
                    {feature.title} {feature.footnote} <QuestionMark />
                  </p>
                </Tooltip>
              </div>
              {tiers.map((tier, key) => {
                return (
                  <div className={styles.check} key={key}>
                    {feature.tiers.indexOf(tier) > -1 && <Checkmark />}
                  </div>
                );
              })}
            </div>
          );
        })}
      </Collapse>
    </div>
  );
};

const FeatureTable = ({ heading, tiers, sections }) => {
  // Detect sticky nav
  /*let offset = 0;
  if (typeof window !== 'undefined') {
    const stickyNav = document.getElementsByClassName('sticky-nav');
    if (stickyNav && stickyNav.length > 0) {
      offset = 84;
    }
  }*/
  const [visibleRows, setVisibleRows] = useState([]);
  const setIsVisible = async (index, isIntersecting) => {
    if (!visibleRows.includes(index) && isIntersecting) {
      await setVisibleRows((old) => [...old, index].sort());
    } else if (visibleRows.includes(index) && !isIntersecting) {
      await setVisibleRows((old) => old.filter((i) => i !== index).sort());
    }
  };

  return (
    <div>
      <h3>{heading}</h3>
      <div className={styles.grid} style={{ '--tierCount': tiers.length, justifyItems: 'center' }}>
        <div />
        {tiers.map((tier, i) => (
          <div className={styles.tierBorder} key={i}>
            <h4 className={styles.tierHeading}>{tier}</h4>
          </div>
        ))}
      </div>

      {sections.map((section, key) => {
        return (
          <CollapsableSection
            key={key}
            index={key}
            setIsVisible={setIsVisible}
            visible={visibleRows[0] === key}
            title={section.title}
            tiers={tiers}
            features={section.features}
            openByDefault={key < 2}
          />
        );
      })}
    </div>
  );
};

FeatureTable.propTypes = {
  // myProp: PropTypes.string.isRequired
};

export default FeatureTable;
